
import Vue from 'vue'

export default Vue.extend({
   name: 'RouteButton',
   props: {
      to: Object,
      label: { type: String, default: 'New' },
      icon: { type: String, default: 'glyphicon-plus' },
      type: { type: String, default: 'btn-default' },
      size: { type: String, default: 'btn-sm' },
      title: { type: String, default: '' },
   },
})
